/* tslint:disable */
/* eslint-disable */
/**
 * Care& API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.9.4
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  ClinicStatisticsNew,
  ErrorResponse,
  FinancialStatistics,
  PaidImmunizationDetail,
  TenantHealthHistory,
  TenantHealthSkippedEmails,
  TenantHealthStats,
} from '../models';
import {
    ClinicStatisticsNewFromJSON,
    ClinicStatisticsNewToJSON,
    ErrorResponseFromJSON,
    ErrorResponseToJSON,
    FinancialStatisticsFromJSON,
    FinancialStatisticsToJSON,
    PaidImmunizationDetailFromJSON,
    PaidImmunizationDetailToJSON,
    TenantHealthHistoryFromJSON,
    TenantHealthHistoryToJSON,
    TenantHealthSkippedEmailsFromJSON,
    TenantHealthSkippedEmailsToJSON,
    TenantHealthStatsFromJSON,
    TenantHealthStatsToJSON,
} from '../models';

export interface GetPaidImmunizationsRequest {
    from: number;
    to?: number;
}

export interface GetTenantHealthRequest {
    tenantId: string;
}

export interface GetTenantHealthHistoryRequest {
    tenantId: string;
    from?: number;
    to?: number;
}

export interface GetTenantHealthSkippedEmailsRequest {
    tenantId: string;
    limit?: number;
}

/**
 * 
 */
export class StatsApi extends runtime.BaseAPI {

    /**
     * Gets the financial stats (Roles: admin)
     */
    async getFinancialStatsRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<FinancialStatistics>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/stats/financial`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => FinancialStatisticsFromJSON(jsonValue));
    }

    /**
        Request Config Getter
     */
    getFinancialStatsRequestOptionsRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): runtime.RequestOpts {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }


        const responseConfig = {
            path: `/stats/financial`,
            method: 'GET' as runtime.HTTPMethod,
            headers: headerParameters,
            query: queryParameters,
        };
        return responseConfig
    }

    /**
     * Gets the financial stats (Roles: admin)
     */
    async getFinancialStats(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<FinancialStatistics> {
        const response = await this.getFinancialStatsRaw(initOverrides);
        return await response.value();
    }

    /**
     * Gets data for all clinics to be used in statistics. (Roles: admin, physician)
     */
    async getNewClinicStatsRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ClinicStatisticsNew>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/stats/clinics`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ClinicStatisticsNewFromJSON(jsonValue));
    }

    /**
        Request Config Getter
     */
    getNewClinicStatsRequestOptionsRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): runtime.RequestOpts {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }


        const responseConfig = {
            path: `/stats/clinics`,
            method: 'GET' as runtime.HTTPMethod,
            headers: headerParameters,
            query: queryParameters,
        };
        return responseConfig
    }

    /**
     * Gets data for all clinics to be used in statistics. (Roles: admin, physician)
     */
    async getNewClinicStats(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ClinicStatisticsNew> {
        const response = await this.getNewClinicStatsRaw(initOverrides);
        return await response.value();
    }

    /**
     * Gets all paid immunizations system-wide with invoice details (Roles: admin)
     */
    async getPaidImmunizationsRaw(requestParameters: GetPaidImmunizationsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<PaidImmunizationDetail>>> {
        if (requestParameters.from === null || requestParameters.from === undefined) {
            throw new runtime.RequiredError('from','Required parameter requestParameters.from was null or undefined when calling getPaidImmunizations.');
        }

        const queryParameters: any = {};

        if (requestParameters.from !== undefined) {
            queryParameters['from'] = requestParameters.from;
        }

        if (requestParameters.to !== undefined) {
            queryParameters['to'] = requestParameters.to;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/stats/paid-immunizations`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(PaidImmunizationDetailFromJSON));
    }

    /**
        Request Config Getter
     */
    getPaidImmunizationsRequestOptionsRaw(requestParameters: GetPaidImmunizationsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): runtime.RequestOpts {
        if (requestParameters.from === null || requestParameters.from === undefined) {
            throw new runtime.RequiredError('from','Required parameter requestParameters.from was null or undefined when calling getPaidImmunizations.');
        }

        const queryParameters: any = {};

        if (requestParameters.from !== undefined) {
            queryParameters['from'] = requestParameters.from;
        }

        if (requestParameters.to !== undefined) {
            queryParameters['to'] = requestParameters.to;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }


        const responseConfig = {
            path: `/stats/paid-immunizations`,
            method: 'GET' as runtime.HTTPMethod,
            headers: headerParameters,
            query: queryParameters,
        };
        return responseConfig
    }

    /**
     * Gets all paid immunizations system-wide with invoice details (Roles: admin)
     */
    async getPaidImmunizations(requestParameters: GetPaidImmunizationsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<PaidImmunizationDetail>> {
        const response = await this.getPaidImmunizationsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Gets tenant system health indicators (Roles: manager)
     */
    async getTenantHealthRaw(requestParameters: GetTenantHealthRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<TenantHealthStats>> {
        if (requestParameters.tenantId === null || requestParameters.tenantId === undefined) {
            throw new runtime.RequiredError('tenantId','Required parameter requestParameters.tenantId was null or undefined when calling getTenantHealth.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/stats/tenant-health/{tenantId}`.replace(`{${"tenantId"}}`, encodeURIComponent(String(requestParameters.tenantId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => TenantHealthStatsFromJSON(jsonValue));
    }

    /**
        Request Config Getter
     */
    getTenantHealthRequestOptionsRaw(requestParameters: GetTenantHealthRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): runtime.RequestOpts {
        if (requestParameters.tenantId === null || requestParameters.tenantId === undefined) {
            throw new runtime.RequiredError('tenantId','Required parameter requestParameters.tenantId was null or undefined when calling getTenantHealth.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }


        const responseConfig = {
            path: `/stats/tenant-health/{tenantId}`.replace(`{${"tenantId"}}`, encodeURIComponent(String(requestParameters.tenantId))),
            method: 'GET' as runtime.HTTPMethod,
            headers: headerParameters,
            query: queryParameters,
        };
        return responseConfig
    }

    /**
     * Gets tenant system health indicators (Roles: manager)
     */
    async getTenantHealth(requestParameters: GetTenantHealthRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<TenantHealthStats> {
        const response = await this.getTenantHealthRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Gets tenant health history snapshots (Roles: manager)
     */
    async getTenantHealthHistoryRaw(requestParameters: GetTenantHealthHistoryRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<TenantHealthHistory>> {
        if (requestParameters.tenantId === null || requestParameters.tenantId === undefined) {
            throw new runtime.RequiredError('tenantId','Required parameter requestParameters.tenantId was null or undefined when calling getTenantHealthHistory.');
        }

        const queryParameters: any = {};

        if (requestParameters.from !== undefined) {
            queryParameters['from'] = requestParameters.from;
        }

        if (requestParameters.to !== undefined) {
            queryParameters['to'] = requestParameters.to;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/stats/tenant-health-history/{tenantId}`.replace(`{${"tenantId"}}`, encodeURIComponent(String(requestParameters.tenantId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => TenantHealthHistoryFromJSON(jsonValue));
    }

    /**
        Request Config Getter
     */
    getTenantHealthHistoryRequestOptionsRaw(requestParameters: GetTenantHealthHistoryRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): runtime.RequestOpts {
        if (requestParameters.tenantId === null || requestParameters.tenantId === undefined) {
            throw new runtime.RequiredError('tenantId','Required parameter requestParameters.tenantId was null or undefined when calling getTenantHealthHistory.');
        }

        const queryParameters: any = {};

        if (requestParameters.from !== undefined) {
            queryParameters['from'] = requestParameters.from;
        }

        if (requestParameters.to !== undefined) {
            queryParameters['to'] = requestParameters.to;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }


        const responseConfig = {
            path: `/stats/tenant-health-history/{tenantId}`.replace(`{${"tenantId"}}`, encodeURIComponent(String(requestParameters.tenantId))),
            method: 'GET' as runtime.HTTPMethod,
            headers: headerParameters,
            query: queryParameters,
        };
        return responseConfig
    }

    /**
     * Gets tenant health history snapshots (Roles: manager)
     */
    async getTenantHealthHistory(requestParameters: GetTenantHealthHistoryRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<TenantHealthHistory> {
        const response = await this.getTenantHealthHistoryRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Gets latest skipped inbound emails from S3 (Roles: manager)
     */
    async getTenantHealthSkippedEmailsRaw(requestParameters: GetTenantHealthSkippedEmailsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<TenantHealthSkippedEmails>> {
        if (requestParameters.tenantId === null || requestParameters.tenantId === undefined) {
            throw new runtime.RequiredError('tenantId','Required parameter requestParameters.tenantId was null or undefined when calling getTenantHealthSkippedEmails.');
        }

        const queryParameters: any = {};

        if (requestParameters.limit !== undefined) {
            queryParameters['limit'] = requestParameters.limit;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/stats/tenant-health-skipped-emails/{tenantId}`.replace(`{${"tenantId"}}`, encodeURIComponent(String(requestParameters.tenantId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => TenantHealthSkippedEmailsFromJSON(jsonValue));
    }

    /**
        Request Config Getter
     */
    getTenantHealthSkippedEmailsRequestOptionsRaw(requestParameters: GetTenantHealthSkippedEmailsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): runtime.RequestOpts {
        if (requestParameters.tenantId === null || requestParameters.tenantId === undefined) {
            throw new runtime.RequiredError('tenantId','Required parameter requestParameters.tenantId was null or undefined when calling getTenantHealthSkippedEmails.');
        }

        const queryParameters: any = {};

        if (requestParameters.limit !== undefined) {
            queryParameters['limit'] = requestParameters.limit;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }


        const responseConfig = {
            path: `/stats/tenant-health-skipped-emails/{tenantId}`.replace(`{${"tenantId"}}`, encodeURIComponent(String(requestParameters.tenantId))),
            method: 'GET' as runtime.HTTPMethod,
            headers: headerParameters,
            query: queryParameters,
        };
        return responseConfig
    }

    /**
     * Gets latest skipped inbound emails from S3 (Roles: manager)
     */
    async getTenantHealthSkippedEmails(requestParameters: GetTenantHealthSkippedEmailsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<TenantHealthSkippedEmails> {
        const response = await this.getTenantHealthSkippedEmailsRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
